import React, {useEffect, useState} from "react";
import LogoWindows from "../img/logo-windows.png";
import LogoMicrosoft from "../img/logo-microsoft.png";
import LogoMac from "../img/logo-mac.png";
import LogoIOS from "../img/logo-ios.png";
import LogoHuawei from "../img/logo-huawei.png";
import LogoAndroid from "../img/logo-android.png";
import LogoMacM1 from "../img/logo-mac-m1.png";

const isAppleSilicon = () => {
    try {
        const canvas = document.createElement('canvas');
        const gl = canvas.getContext('webgl');

        if (!gl) return false;

        // Best guess if the device is an Apple Silicon
        // <https://stackoverflow.com/a/65412357>
        return gl.getSupportedExtensions().indexOf('WEBGL_compressed_texture_etc') !== -1;
    } catch (error) {
        return false;
    }
}

const createReader = (platform, isPrimary, logo, src) => {
    return {
        platform,
        isPrimary,
        logo,
        src
    }
}

const getReaders = () => {
    const userAgent = navigator.userAgent;
    // Since iPadOS 13, iPads report "Macintosh" in the UA by default. Distinguish
    // them from real Macs via touch support — there are no Macs with touchscreens.
    const isIPadOnMac = /Macintosh/.test(userAgent) && navigator.maxTouchPoints > 1;
    return [
        createReader(
            "Microsoft",
            /NT 10.0/.test(userAgent),
            LogoMicrosoft,
            "https://www.microsoft.com/en-za/p/snapplify/9nrcwrhppxrj?activetab=pivot:overviewtab",
        ),
        createReader(
            "Windows",
            /Windows NT 6\.[123]/.test(userAgent),
            LogoWindows,
            "https://getsnapplify.com/release/Snapplify.msi",
        ),
        createReader(
            "Apple Silicon",
            /Macintosh/.test(userAgent) && isAppleSilicon() && !isIPadOnMac,
            LogoMacM1,
            "https://getsnapplify.com/release/Snapplify-AppleSilicon.pkg",
        ),
        createReader(
            "Mac OS",
            /Macintosh/.test(userAgent) && !isAppleSilicon() && !isIPadOnMac,
            LogoMac,
            "https://getsnapplify.com/release/Snapplify.pkg",
        ),
        createReader(
            "iOS",
            /iPhone|iPad/.test(userAgent) || isIPadOnMac,
            LogoIOS,
            "https://itunes.apple.com/app/snapplify-viewer/id479343631?ls=1&mt=8&at=10lbTQ",
        ),
        createReader(
            "Android",
            /^(?!.*Huawei|.*HUAWEI|.*CrOS).*Android/.test(userAgent),
            LogoAndroid,
            "https://play.google.com/store/apps/details?id=za.co.snapplify",
        ),
        createReader(
            "Huawei",
            /HUAWEI|Huawei/.test(userAgent),
            LogoHuawei,
            "https://appgallery.huawei.com/app/C102670933",
        )
    ];
}

export const ReaderActive = () => {
    const [readers, setReaders] = useState([]);

    useEffect(() => {
        setReaders(getReaders());
    }, []);

    if (readers.length > 0 && !readers.some(r => r.isPrimary)) {
        return (
            <div>
                <div className="section_heading ">
                    <h1>Hello Human. <br/> I, Snappbot, don't have a native Reader recommendation for your platform — try one of the options below.</h1>
                </div>
            </div>
        );
    }

    return (
        <div>
            {readers.map((i) => {
                return (
                    i.isPrimary ?
                        <div key={i.platform}>
                            <div className="section_heading ">
                                <h1>Hello Human. <br/> I, Snappbot, recommend the Snapplify Reader for <strong>{i.platform}</strong> on your device!</h1>
                            </div>
                            <a href={i.src} target="_blank" rel="noopener noreferrer"> <img className="os-primary" src={i.logo} alt={`Download Snapplify Reader for ${i.platform}`}/> </a>
                        </div> : null
                )
            })}
        </div>
    )
}

export const ReaderStatic = () => {
    const [readers, setReaders] = useState([]);

    useEffect(() => {
        setReaders(getReaders());
    }, []);

    return (
        <div className="text-center">
            <h3 className="section_text">
                If I got it wrong, perhaps try one of the following devices
            </h3>
            <div>
                {readers.map((i) => {
                    return (
                        !i.isPrimary ?
                            <a key={i.platform} href={i.src} target="_blank" rel="noopener noreferrer"> <img className="os-secondary" src={i.logo} alt={`Snapplify Reader for ${i.platform}`}/></a>
                            : null
                    )
                })}
            </div>
            <h3 className="section_text">
            </h3>
        </div>
    )
}
